import { intersection, uniq } from 'ramda'
import config from '../config'

// TODO: temp, fix after change api url
export const generateDownloadLink = (fileId) => `https://webappadmin.blutacho.com/api/download-document/${fileId}`

export const hasLicenceToViewArticle = (article, userLicences) => {
  // check if article has some licences
  if (!article.licences || article.licences.length === 0) {
    return true
  }
  // check if user has needed licence
  return intersection(article.licences, userLicences).length > 0
}

export const isArticleForVehicleType = (article, vehicleType) => {
  // check if article has vehicle type restrictions
  if (!article.vehicles || article.vehicles.length === 0) {
    return true
  }
  // check if vehicleType is in article's vehicles types
  return article.vehicles.includes(vehicleType)
}

export const isArticleForCountry = (article, countryId) => {
  // check if article has countries restrictions
  if (!article.countries || article.countries.length === 0) {
    return true
  }
  // check if countryId is in article's countries
  return article.countries.includes(countryId)
}

export const isArticleForLanguage = (article, langId) => {
  return article.language_id === langId
}

export const isMobileModule = (article) => {
  return article.gps || // GPS type of article
    article.stopwatch ||  // Stopwatch type of article
    article.reader || // Reader type of article
    article.sos // SOS type of article
}

/**
 * Return all recursive categories filter ids
 * @param items
 * @param key
 * @param recursive
 */
export const findIds = (items, key, recursive) => {
  let ids = []

  for (let i = 0; i < items.length; i++) {
    if (recursive !== false && 'categories' in items[i] && items[i].categories.length > 0)
      ids = ids.concat(findIds(items[i].categories, key))

    if (items[i][key] && items[i][key].length)
      ids = ids.concat(items[i][key])
  }

  return uniq(ids)
}

export const prepareStringForSearch = (name) => {
  let sd = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ. ",
    bz = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ",
    tx = ''

  if (!name) {
    return ''
  }

  name = name.trim()

  for (let i = 0; i < name.length; i++) {
    let indexOf = sd.indexOf(name.charAt(i))
    if (indexOf !== -1)
      tx += bz.charAt(indexOf)
    else
      tx += name.charAt(i)
  }

  tx = tx.toLowerCase()

  return tx
}
